import {useEffect,useState } from 'react'; 
import { BigNumber, ethers } from 'ethers';
import { useWeb3React } from '@web3-react/core';
import {useParams,NavLink,useNavigate} from "react-router-dom";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select'; 
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography'; 
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Card from '@mui/material/Card'; 
import Divider from '@mui/material/Divider'; 
import CardHeader from '@mui/material/CardHeader';  
import { Icon } from "@iconify/react"; 
import { toast } from "react-toastify"; 
import Iconify from './iconify/index';  
import NftCard from './NftCard';  
// import {useNftsForCollectionNew,usePagination} from  "../hooks/useNfts";   
// import { 
//   getNetworkprcnameFromChainId, 
// } from '../utils/blockchain'; 
import nftsnew  from '../config/nftsnew.json';
export default function Nftsnew() {   
     const mchainid = 137;
     const mcontractAddress = '0xEFD114Ba2b4D750990cc5717774D112c16bDdD3c';  
//   let mchain = getNetworkprcnameFromChainId(mchainid) //'polygon-mainnet'; 
//   const { data ,isFetching } = useNftsForCollectionNew(
//     mcontractAddress, 
//     null,
//     8,
//     mchain,
//     true
//   );  
   // console.log('nfts:',nfthot_2);  
   
 
  const navigate = useNavigate();
  const newhandleClick = () => {
      toast.success("comming soon...."); 
     // navigate("/nftslistpage/"+mchainid+"&"+mcontractAddress, { replace: true });       
  } 

  return (
    <Container>   
      <Stack direction="row" alignItems="center" justifyContent="space-between"  mb={5} mt={5}>
        <Typography variant="h5"  >
         Newest NFTS 
        </Typography> 
        <Button  onClick={newhandleClick}  variant="outlined"   startIcon={<MoreVertIcon   />}>
         more...
        </Button>
      </Stack> 

      <Grid container spacing={3}>
        {nftsnew && nftsnew?.map((nft:any,index:number) => (
          <Grid key={index} xs={12} sm={6} md={3}>
            <NftCard chainid={mchainid}  nft={nft} />
          </Grid>
        ))}
     
      </Grid> 
    </Container>
  );
}
